import type { ErrorObject } from '@vuelidate/core';
import { unref } from 'vue';

const unwrapVuelidateErrorMessages = (errors: string[] | ErrorObject[]) =>
  errors.some((error) => typeof error === 'string')
    ? (errors as string[])
    : (errors as ErrorObject[]).map(({ $message }) => unref($message));

export default unwrapVuelidateErrorMessages;
